import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Table from './TableCash';
import SearchForm from './SearchForm';
import { ToastContainer, toast } from 'react-toastify';

export default class Cashes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cashes: [],
            searchConditions: {},
            lastPage: 1,
            currentPage: 1,
            removeDirectlyClick: 1,
            fileUpload: null,
            from: '',
            to: '',
            total: '',
        };
        this.handleSearch = this.handleSearch.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleUploadCsv = this.handleUploadCsv.bind(this);
        this.onChangeUpload = this.onChangeUpload.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }
    
    /**
     * Init data and form cash or list cash
     */
    componentWillMount() {
        const keySearch_str = this.props.location.search.substring(1);
        let keySearch_arr = {page: 1};
        if (keySearch_str) {
            keySearch_arr = JSON.parse('{"' + decodeURI(keySearch_str.replace(/&/g, "\",\"")).replace(/=/g,"\":\"").replace('%3A', ':') + '"}');
        }
        
        //always get list data
        axios.post('/api/cashes/search', keySearch_arr).then(response => {
            this.setState({
                cashes: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                searchConditions: keySearch_arr,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: keySearch_str
            });
        });
    }
    
    /**
     * Sort data
     */
    handleSort(key) {
        //add sort params to search conditions
        let newSearchConditions = this.state.searchConditions;
        newSearchConditions.sort_column = key.sort_column;
        newSearchConditions.sort_type = key.sort_type;
        this.setState({
            searchConditions: newSearchConditions
        });
        axios.post('/api/cashes/search', newSearchConditions).then(response => {
            this.setState({
                cashes: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                searchConditions: newSearchConditions,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(newSearchConditions)
            });
        });
    }
    
    /**
     * Get search data
     */
    handleSearch(key) {
        this.setState({
            searchConditions: key
        });
        axios.post('/api/cashes/search', key).then(response => {
            this.setState({
                cashes: response.data.data,
                lastPage: response.data.last_page,
                currentPage: response.data.current_page,
                from: response.data.from,
                to: response.data.to,
                total: response.data.total,
            });
            this.props.history.push({
                search: $.param(key)
            });
        });
    }
    
    /**
     * Handle upload csv
     */
    handleUploadCsv() {
        const formData = new FormData();
        formData.append('file', this.state.file)
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        if(this.state.file != null){
            $('.cover-loading').show();
            axios.post('/api/cashes/upload', formData, config).then(response => {
                if (response.data.success) {
                    location.reload();
                } else {
                    $('.cover-loading').hide();
                    $('.upload-error').html(response.data.errors).show();
                }
            }).catch(error => {
                $('.cover-loading').hide();
                $('.upload-error').html(error.response.data.errors).show();
            });
        }
    }
    
    onChangeUpload(e) {
        this.setState({file:e.target.files[0]})
    }
    
    onCheckAllCheckBox(e) {
        $(".form-check-input").prop('checked', e.target.checked);
    }

    /**
     * Edit cash
     * staff: Object Cash
     */
    handleEdit(cash) {
        this.props.history.push('/cashes/edit/' + cash.id);
    }
    
    /**
     * Handle redirect
     */
    handleRedirect(e) {
        e.preventDefault()
        this.props.history.push(e.currentTarget.getAttribute('href'));
    }
    
    render () {
        const option = {
            null:{text:'未承認',classHTML:'text-gray'},
            0:{text:'申請のみ',classHTML:'badge bg-yellow text-white'},
            100:{text:'送金中',classHTML:'badge bg-cyan text-white'},
            1:{text:'受け取り待ち',classHTML:'badge bg-cyan text-white'},
            2:{text:'受け取り済',classHTML:'badge bg-purple text-white'},
            92:{text:'補正完了',classHTML:'badge bg-light'},
            93:{text:'承認待ち',classHTML:'badge bg-cyan text-white'},
            94:{text:'支払取消',classHTML:'badge bg-light'},
            95:{text:'受取期限切れ',classHTML:'badge bg-purple text-white'},
            96:{text:'キャンセル済',classHTML:'badge bg-light'},
            97:{text:'7bankAPI失敗（リクエスト）',classHTML:'badge bg-light'},
            98:{text:'7bankAPI失敗（レスポンス）',classHTML:'badge bg-pink text-white'},
            99:{text:'審査NG',classHTML:'badge bg-light'}
        };
        const option_remittance_result = {
            null:{text:''},
            100:{text:'送金中',classHTML:'badge bg-cyan text-white'},
            1:{text:'送金済み',classHTML:'badge bg-purple text-white'},
            2:{text:'送金済み',classHTML:'badge bg-purple text-white'},
            95:{text:'送金済み',classHTML:'badge bg-purple text-white'},
            96:{text:'キャンセル済',classHTML:'badge bg-light'},
            97:{text:'失敗',classHTML:'badge bg-pink text-white'},
            99:{text:'審査NG',classHTML:'badge bg-light'}
        };
        const option_receipt_result = {
            null:{text:''},
            2:{text:'受取済み',classHTML:'badge bg-purple text-white'},
            95:{text:'受取期限切れ',classHTML:'badge bg-light'},
            98:{text:'失敗',classHTML:'badge bg-pink text-white'},
        };
        const option_msg_way_cd = {
            null:{text:''},
            10:{text:'自社通知',classHTML:''},
            20:{text:'代行（Eメール）',classHTML:''},
            21:{text:'代行（SMS）',classHTML:''},
        };
        const columns = [
            {name: 'id', title: 'ID', isSort: 1, type: 'text'},
            {name: 'remittance_request_management', title: '送金依頼明細番号\n送金依頼管理番号', break_line: 'text_break_line_header', type: 'text_break_line'},
            {name: 'first_last_name', title: '申請者', isSort: 1, type: 'text', isSearch:true},
            {name: 'msg_way_cd', title: '通知手段', isSort: 1, type: 'option', option:option_msg_way_cd},
            {name: 'staffEmail', title: 'メールアドレス', isSort: 1, type: 'text'},
            {name: 'request_point', title: '申請額', isSort: 1, type: 'convert_to_number', prefix:'¥'},
            {name: 'request_fee', title: '手数料', isSort: 1, type: 'convert_to_number', prefix:'¥'},
            {name: 'rmtc', title: '振込額', isSort: 1, type: 'convert_to_number', prefix:'¥'},
            {name: 'status', title: 'ステータス', isSort: 1, type: 'option', option:option},
            {name: 'remittance_result', title: '送金結果', isSort: 1, type: 'option', option:option_remittance_result},
            {name: 'receipt_result', title: '受取結果', isSort: 1, type: 'option', option:option_receipt_result},
            {name: 'set_receipt', title: '受取済み', isSort: 0, type: 'checkbox_receipt'},
            {name: 'created_at', title: '申請日', isSort: 1, type: 'date_time'},
            {name: 'request_send_day', title: '振込日', isSort: 1, type: 'date_time'},
            {name: 'result_get_day', title: '受取日', isSort: 1, type: 'date_time'},
            {name: 'memo', title: 'メモ', isSort: 0, type: 'text'},
            {name: 'action', title: '操作', isSort: 0, type: 'action', elements: ['edit'], edit_except_ids: []}
        ];
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0">
                                <li className="breadcrumb-item"><a onClick={this.handleRedirect} href="/home">ダッシュボード</a></li>
                                <li className="breadcrumb-item active" aria-current="page">現金申請</li>
                            </ol>
                        </nav>
                    </div>
		</div>

		<main id="main">
            <div className="row">
                <div className="col-sm-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col">
                                    <h4 className="mt-2 mb-0 page-title">現金申請一覧</h4>
                                </div>
                                <div className="col text-right">
                                    <button className="btn btn-light btn-space" type="button" data-toggle="collapse" data-target="#search-cashes" aria-expanded="false" aria-controls="search-cashes">絞込検索</button>
                                    <button className="btn btn-light btn-space" data-toggle="modal" title="CSVファイルをアップロード" data-target="#uploadModal"><i className="material-icons">get_app</i> 送金完了データ</button>
                                    <button className="btn btn-light" title="受取済みチェック"><label htmlFor="all">受取済みチェック　<input type="checkbox" id="all" onChange={this.onCheckAllCheckBox}/> </label> </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <SearchForm onSearch={this.handleSearch} />
                                </div>
                            </div>

                            <div className="modal fade" id="uploadModal" tabIndex="-1" aria-hidden="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content cover-loading-parent">
                                        <div className="modal-header">
                                            <h5 className="modal-title" id="exampleModalLabel">CSVファイルをアップロード</h5>
                                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="alert alert-danger upload-error block-hidden"></div>
                                            <input type="file" id="csv-file" accept=".csv" onChange={this.onChangeUpload} />
                                        </div>
                                        <div className="card-footer text-center">
                                            <button type="button" className="btn btn-secondary clearfix" data-dismiss="modal">戻る</button>
                                            <button type="button" className="btn btn-primary" onClick={this.handleUploadCsv}>アップロード</button>
                                        </div>
                                        <div className="cover-loading block-hidden">処理中...</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Table onSearch={this.handleSearch} onEdit={this.handleEdit} header={columns} data={this.state.cashes} onSort={this.handleSort} from={this.state.from} to={this.state.to} total={this.state.total}
                            myPagination={1} searchConditions={this.state.searchConditions} lastPage={this.state.lastPage} currentPage={this.state.currentPage} removeClick={this.state.removeDirectlyClick}/>
                    </div>
                </div>
            </div>
		</main>
        <ToastContainer />
            </React.Fragment>
        );
    }
}
